/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPolymorph = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M17 2.197 22.869 11H11.132L17 2.197zM5 6.586l4.293-4.293 1.414 1.414L6.414 8H9v2H3V4h2v2.586zM14.868 9h4.263L17 5.803 14.868 9zM2 14h8v8H2v-8zm2 2v4h4v-4H4zm13.586 0H15v-2h6v6h-2v-2.586l-4.293 4.293-1.414-1.414L17.586 16z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPolymorph as Polymorph };
